import {Component, Emit, Prop, Vue,Watch} from 'vue-property-decorator';
import moment from 'moment';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue';
import SelectFromAgriFields from '@/components/Record/SelectFromAgriFields/SelectFromAgriFields.vue'
import SelectFromWorkRecords from '@/components/Record/SelectFromWorkRecords/SelectFromWorkRecords.vue'
import RecordInfo from '@/components/Record/RecordInfo/RecordInfo.vue';
import { File, 
    RecordInfoModel, 
    HarvestShippingItem, 
    HarvestShipping, 
    SelectAgriFieldAndPlanting, 
    HarvestRecordData, 
    HarvestRecordItem ,
    Machine,
    Worker,
    WorkTimeState,
    ShippingDestinationsHarvestRecordData,
    Item} from '@/types/Component';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import SelectTime from '@/components/Record/WorkRecord/SelectTime/SelectTime.vue'
import SelectInterval from '@/components/Record/WorkRecord/SelectInterval/SelectInterval.vue'
import MachineSelectModal from '@/assets/common/Modal/ItemSelectModal/MachineSelectModal/MachineSelectModal.vue'
import WorkerSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkerSelectModal/WorkerSelectModal.vue'
import WorkRecordModal from '@/assets/common/Modal/WorkRecordModal/WorkRecordModal.vue';

type WorkerPost = {
    processType: string;
    worker_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    plan_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    actual_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    plan_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    actual_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    plan_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    actual_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    plan_work_time: number, // 作業時間
    actual_work_time: number, // 作業時間
    memo: string, // メモ
    kind: "SCHEDULE" | "ACTUAL";
}

type MachinePost = {
    processType: string;
    machine_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    memo: string, // メモ
}

@Component({
    components: {
        Thumbnail,
        EditModal,
        SelectFromPlantings,
        SelectFromWorkRecords,
        SelectFromAgriFields,
        RecordInfo,
        SelectTime,
        SelectInterval,
        MachineSelectModal,
        WorkerSelectModal,
        WorkRecordModal
    }
})

export default class HarvestRecord extends Vue {
    
    @Prop({ default: false })
    private readonly isShow!: boolean;

    closeModal() {
        if (this.refresh) {
            this.$emit('update:isRefresh', true);
            this.refresh = false;
        }
        if(this.isHarvestOpen === 'true' && this.id == null || this.isHarvestOpen === 'true' && this.id != null ){
            this.$root.$emit('header-inert', false);
            this.$router.push(`/${this.$route.query.return_to}?date=${this.date}`).then(() => {return})
        }
        else{
            if (store.getters.isInputChanged) {
                const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
                if (confirm) {
                    store.dispatch("doUpdateIsInputChanged", false);
                    this.editTargetId=''
                    this.modeType =''
                    this.harvestRecordId=''
                    this.$emit('update:isShow', false);
               }
            }else{
                this.editTargetId=''
                this.modeType =''
                this.harvestRecordId=''
                this.$emit('update:isShow', false);
            }
            this.plantingBasicUnitId='';
        }
    }

    @Prop()
    private id?: string

    @Prop()
    private mode?: string

    @Prop({ default: false })
    private readonly isRefresh!: boolean;

    @Watch("isShow")
    handleHarvestRecordModal() {
            if(this.id) {
                this.editTargetId = this.id
                this.harvestRecordId = this.id
            } else {
                this.editTargetId = ''
            }
            if(this.mode) {
                this.modeType = this.mode
            }
            this.init()
    }
   
    private date = moment(new Date()).format('YYYY-MM-DD')
    private measurementTimingId = ''
    private measurementTimings: HarvestShippingItem[] = []
    private plantingAndAgriField: SelectAgriFieldAndPlanting = {
        agriField: {
            id: '',
            name: '',
            plantedArea: 0
        },
        planting: {
            id: '',
            name: '',
            cropFamicId: ''
        }
    }
    private weightUnits: HarvestShippingItem[] = []
    private qualityStandards: HarvestShippingItem[] = []
    private harvestRecordData: HarvestRecordData[] = [
        {
            harvestRecordDataId :'',
            harvestRecordId:"",
            weightPerUnit:1,
            qualityStandardId: '',
            qualityStandardName: '',
            quantity: null,
            remainingQuantity:null,
            weightUnitId: null,
            weightUnitName: '',
            harvestLotNumber :'',
            qualityDisplayFlag: '',
            processType : '',
            updatedHarvestRecordData:''
        }
    ]
    private machines :Machine[] =[]
    private workers :Worker[] =[]
    private shippingDestinationsHarvestRecordData : ShippingDestinationsHarvestRecordData [] =[]
    private lotNumber = ''
    private existLotNumber = false
    private images: File[] = []
    private selectedImages: File[] = []
    private deletedImages: File[] = []
    private memo = ''
    private workRecordOption = ''
    workRecordOptionDef = '';
    private modalBaseUrl = ''
    private showEditModal = false
    private showSelectFromPlantings = false
    private showSelectFromAgriFields = false
    private isCopy = false
    private apiBaseUrl = '/harvest_records'
    private recordInfo: RecordInfoModel | null = null
    private isEditable = true
    private workerInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private machineInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private targetSelectTime: WorkTimeState | null = null
    private showSelectTime = false;
    private showSelectInterval = false
    private selectTimeIndex: number | 'all' | undefined;
    private workerOrMachine: 'WORKER' | 'MACHINE' = 'WORKER'
    private showMachineSelect = false
    private showWorkerSelect = false
    private modeType =''
    private editTargetId =''
    private harvestRecordId =''
    private headerTitle = ''
    private subTitle = '';
    private workRecordId = ''
    private workUnitName = ''
    private existingWorkRecordId = '';
    private plantingBasicUnitId:any =''
    private showWork = false
    private workMode: string | null = null;
    private refresh = false;
    private showSelectFromWorkRecords = false
    private workunits = [] as any[];
    private selectedWorkUnitId = null;
    private workerGoalWorkUnitId = null;
    private workerGoalWorkUnitName = ''
    deletedHarvestRecordDataIds = [] as string [];
    private originalWorkers = [] as Worker[];
    private originalMachines = [] as Machine[];
    private originalHarvestRecordData = [] as HarvestRecordData[];
    private updatedHarvestTime : string | null = null;
    private workRecordUpdated : string | null = null;
    private harvestRecordWorkRecordsUpdated : string | null = null;
    private alertMessage = 'リクエストに失敗しました。\n'
    private isLoading = false;

    @Prop()
    private isHarvestOpen!: string
    @Prop()
    private harvestDate!: string

    get isAnyHarvestModalOpen(): boolean {
    return (
    this.showSelectFromPlantings ||
    this.showSelectFromAgriFields ||
    this.showSelectTime ||
    this.showSelectInterval ||
    this.showMachineSelect ||
    this.showWorkerSelect ||
    this.showSelectFromWorkRecords || 
    this.showSelectFromPlantings || 
    this.showWork ||
    this.showEditModal
    )
    }

    private created() {
        this.handleHarvestRecordModal();
    }

    private init() {
        this.images = []
        this.selectedImages = []
        this.deletedImages = []
        if(this.modeType == 'edit'){
            this.headerTitle = '収穫記録編集'
            this.getHarvestRecord(this.editTargetId);
        }
        else{
        this.headerTitle = '収穫記録新規作成'
        this.subTitle = this.modeType === 'copy' ? '（複製）': '';
        this.date = this.harvestDate ? this.harvestDate : moment(new Date()).format('YYYY-MM-DD')
        this.measurementTimingId = ''
        this.plantingAndAgriField = {
            agriField: {
                    id: '',
                    name: '',
                plantedArea: 0
                },
                planting: {
                    id: '',
                    name: '',
                    cropFamicId: ''
                }
            }
        this.harvestRecordData = [
                {
                    harvestRecordDataId:'',
                    harvestRecordId:"",
                    weightPerUnit:1,
                    qualityStandardId: '',
                    qualityStandardName: '',
                    quantity: null,
                    remainingQuantity:null,
                    weightUnitId: null,
                    weightUnitName: '',
                    harvestLotNumber:'',
                    qualityDisplayFlag:'',
                    processType : '',
                    updatedHarvestRecordData:''
                }
            ]
        this.workRecordId = ''
        this.existingWorkRecordId = ''
        this.workers =[]
        this.machines =[]
        this.originalMachines = []
        this.originalWorkers = []
        this.originalHarvestRecordData = []
        this.lotNumber = ''
        this.existLotNumber = false
        this.images = []
        this.selectedImages = []
        this.deletedImages = []
        this.memo = ''
        this.showEditModal = false
        this.showSelectFromPlantings = false
        this.showSelectFromAgriFields = false
        this.isCopy = false
        this.isEditable= true
        this.updatedHarvestTime = ''
        this.shippingDestinationsHarvestRecordData =[]
        this.getMeasurementTiming()
        this.getQualityStandards()
        this.getWeightUnits()
        if (this.editTargetId) {
            this.getHarvestRecord(this.editTargetId)
        } else {
            this.getPreferredWorkOption()
        }
        }
        this.getWorkUnits();
        this.selectedWorkUnitId = null;
        this.workerGoalWorkUnitName = '';
        this.deletedHarvestRecordDataIds = [];
    }

    private getHarvestRecord(id: string) {
        this.measurementTimingId = ''
        this.images = []
        this.selectedImages = []
        this.deletedImages = []
        this.$apiClient.doRequest('get', '/harvest_records/' + id).then(ret => {
            this.existingWorkRecordId = ret.work_record_id;
            this.workRecordId = ret.work_record_id;
            if(ret.work_unit != null){
                this.workerGoalWorkUnitName = ret.work_unit.name;
                this.selectedWorkUnitId = ret.work_unit.id;
            }
            const item = toCamel(ret) as HarvestRecordItem
            
            this.workRecordOption = item.workRecordOption
            this.workRecordOptionDef = item.workRecordOption
            if (this.modeType === "edit") {
                this.isEditable = item.isEditable
            } else {
                if (this.modeType === 'copy') {
                    this.workRecordId = '';
                }
                this.isEditable = true
            }
            const parent = this.$parent as any
            parent.isEditable = item.isEditable
            this.date = item.harvestDate
            this.plantingAndAgriField = {
                agriField: {
                    id: item.agriField?.id,
                    name: item.agriField?.name,
                    plantedArea: item.agriField?.plantedArea
                },
                planting: {
                    id: item.planting?.id,
                    name: item.planting?.name,
                    cropFamicId: ''
                }
            }
            this.plantingBasicUnitId =this.plantingAndAgriField.planting.id
            this.measurementTimingId = item.measurementTimingId
            const workerRecord : Worker[] = item.workers.map((item: any) => {
                return {
                    worker: {
                        id: item.worker.id, 
                        name: item.worker.name 
                    },
                    startWorktime: item.actualStartWorktime ,
                    planStartWorktime: item.planStartWorktime,
                    actualStartWorktime: item.actualStartWorktime,
                    endWorktime: item.actualEndWorktime,
                    planEndWorktime: item.planEndWorktime, 
                    actualEndWorktime: item.actualEndWorktime,
                    restTime:  item.actualRestTime,
                    planRestTime: item.planRestTime, 
                    actualRestTime: item.actualRestTime,
                    workTime:  item.actualWorkTime ,
                    planWorkTime: item.planWorkTime, 
                    actualWorkTime: item.actualWorkTime,
                    quantity:item.quantity,
                    memo: item.memo,
                    kind: item.kind,
                    workerUpdatedTime:item.workerUpdatedTime
                };
            });
            this.workers = workerRecord
            this.machines = item.machines
            this.originalWorkers = this.workers.map(w => ({...w}));
            this.originalMachines = this.machines.map(m => ({...m}))
            this.harvestRecordData = item.harvestRecordData.map(record => ({ ...record, processType: '' }));
            this.originalHarvestRecordData = item.harvestRecordData.map(record => ({ ...record, processType: '' }));
            this.lotNumber = item.lotNumber
            this.memo = item.memo
            this.updatedHarvestTime = item.updatedHarvestTime,
            this.workRecordUpdated = item.workRecordUpdated,
            this.harvestRecordWorkRecordsUpdated = item.harvestRecordWorkRecordsUpdated
            this.recordInfo = {
                createdUser: item.createdUser,
                created: item.created,
                updatedUser: item.updatedUser,
                updated: item.updated
            }
            this.shippingDestinationsHarvestRecordData = item.shippingDestinationsHarvestRecordData
            this.getMeasurementTiming()
            this.getQualityStandards()
            this.getWeightUnits()
            this.getPlantingWeightUnitId()
            let workerInputTypeIsTimePoint
            if(this.workers.length) {
                workerInputTypeIsTimePoint = this.workers
                .map(w => 
                    w.actualStartWorktime !== null && w.actualEndWorktime !==null && w.actualRestTime!==null
                    ).reduce((res, b) => 
                    res && b
                    )
            }
            this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
            let machineInputTypeIsTimePoint
            if(this.machines.length) {
                machineInputTypeIsTimePoint = this.machines
                    .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                    .reduce((res, b) => res && b)
            }
            this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
            if(!this.isCopy && item.fileId.length > 0) {
                const promise: any = []
                item.fileId.forEach((id: string) => {
                    promise.push(this.$apiClient.doRequest('get', `/harvest_records/${this.harvestRecordId}/images/${id}`))
                })
                Promise.all(promise).then(ret => {
                    const file = toCamel(ret) as File[]
                    this.images = file
                })
            }
            else{
                this.images = []
            }
        })
    }

    private getMeasurementTiming() {
        this.$apiClient.doRequest('get', '/measurement_timings?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.measurementTimings = item.measurementTimings
        }).catch(() => {
            return
        })
    }

    private getQualityStandards() {
        this.$apiClient.doRequest('get', '/quality_standards?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.qualityStandards = item.qualityStandards
        }).catch(() => {
            return
        })
    }

    private getWeightUnits() {
        this.$apiClient.doRequest('get', '/weight_units?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.weightUnits = item.weightUnits
        }).catch(() => {
            return
        })
    }

    private getPreferredWorkOption() {
        this.$apiClient.doRequest('get', `/graphScreenManagement/HARVESTRECORD`).then(ret => {
            this.workRecordOption = ret.workRecordOption;
        })
    }

    @Watch('workRecordOption')
    private async resetWorkData() {
        this.workers = []
        this.machines = []
        this.workRecordId = ''
        this.workerGoalWorkUnitName = ''
        this.selectedWorkUnitId = null
        if (this.mode == "edit" && ((this.workRecordOptionDef === 'WITHWORK' && this.workRecordOption === 'WITHWORK') || (this.workRecordOptionDef === 'LINKWORK' && this.workRecordOption === 'LINKWORK'))) {
            this.workRecordId = this.existingWorkRecordId
            if (this.existingWorkRecordId) {
                const res = await this.$apiClient.doRequest('get', '/work_records/' + this.existingWorkRecordId)
                this.commitWorkRecord(res);
            }
        } else if (this.mode == "copy" && this.workRecordOptionDef === 'WITHWORK' && this.workRecordOption === 'WITHWORK') {
            if (this.existingWorkRecordId) {
                const res = await this.$apiClient.doRequest('get', '/work_records/' + this.existingWorkRecordId)
                this.commitWorkRecord(res);
            }
        } 
    }

    private handleWorkRecordPopup() {
        const errmsg: string[] = [];
        if (!this.date) errmsg.push('日付を選択してください。');
        if (!this.plantingAndAgriField.agriField.id || !this.plantingAndAgriField.planting.id) {
            errmsg.push('作付・圃場を選択してください。');
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'));
            return false;
        }
        return this.showSelectFromWorkRecords = true;
    }

    private commitWorkRecord(workRecord: any) {
        this.workers = []
        this.machines = []
        this.workRecordId = workRecord.id;
        const workerRecord : Worker[] = workRecord.workers.map((item: any) => {
            return {
                worker: {
                    id: item.worker.id, 
                    name: item.worker.name 
                },
                startWorktime: workRecord.kind === "SCHEDULE" ? item.plan_start_worktime : item.actual_start_worktime,
                planStartWorktime: item.plan_start_worktime,
                actualStartWorktime: item.actual_start_worktime,
                endWorktime: workRecord.kind === "SCHEDULE" ? item.plan_end_worktime : item.actual_end_worktime,
                planEndWorktime: item.plan_end_worktime, 
                actualEndWorktime: item.actual_end_worktime,
                restTime: workRecord.kind === "SCHEDULE" ? item.plan_rest_time : item.actual_rest_time,
                planRestTime: item.plan_rest_time, 
                actualRestTime: item.actual_rest_time,
                workTime: workRecord.kind === "SCHEDULE" ? item.plan_work_time : item.actual_work_time,
                planWorkTime: item.plan_work_time, 
                actualWorkTime: item.actual_work_time,
                quantity:item.quantity,
                memo: item.memo,
                kind: "ACTUAL",
                workerUpdatedTime: item.workerUpdatedTime ? item.workerUpdatedTime : item.worker_updated_time
            };
        });
        this.selectedWorkUnitId = workRecord.workUnitId !== undefined ? workRecord.workUnitId : workRecord.work_unit?.id ?? null;
        this.workerGoalWorkUnitName = workRecord.workUnitName ? workRecord.workUnitName : workRecord.work_unit?.name;
        this.workers = workerRecord;
        let workerInputTypeIsTimePoint;
        if (this.workers.length) {
            workerInputTypeIsTimePoint = this.workers
            .map(w => workRecord.kind === "SCHEDULE" ?  w.planStartWorktime !== null && w.planEndWorktime !== null && w.planRestTime !== null : w.actualStartWorktime !== null && w.actualEndWorktime !== null && w.actualRestTime !== null)
            .reduce((res, b) => res && b)
        }
        this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
        const machineRecord : Machine[] = workRecord.machines.map((item: any) => {
            return {
                machine: {
                    id: item.machine.id, 
                    name: item.machine.name 
                },
                startWorktime: item.start_worktime,
                endWorktime: item.end_worktime,
                restTime: item.rest_time,
                workTime: item.work_time,
                memo: item.memo,
                machineUpdatedTime: item.machineUpdatedTime ? item.machineUpdatedTime : item.machine_updated_time
            };
        });
        let machineInputTypeIsTimePoint;
        this.machines = machineRecord;
        this.originalWorkers = this.workers.map(w => ({...w}));
        this.originalMachines = this.machines.map(m => ({...m}))
        if (this.machines.length) {
            machineInputTypeIsTimePoint = this.machines
                .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                .reduce((res, b) => res && b)
        }
        this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
        this.showSelectFromWorkRecords = false
    }

    private updateItems(baseUrl: string) {
        switch (baseUrl) {
            case '/weight_units':
                this.getWeightUnits()
                break
            case '/measurement_timings':
                this.getMeasurementTiming()
                break
            case '/quality_standards':
                this.getQualityStandards()
                break
        }
    }

    private closeEditModal() {
        this.showEditModal = false
    }

    private commitPlantingAndField(item: SelectAgriFieldAndPlanting) {
        this.showSelectFromPlantings = false
        this.showSelectFromAgriFields = false
        this.plantingAndAgriField = {
            agriField: {
                id: item.agriField.id,
                name: item.agriField.name,
                plantedArea: item.agriField.plantedArea
            },
            planting: {
                id: item.planting?.id,
                name: item.planting?.name,
                cropFamicId: ''
            }
        }
        this.getPlantingWeightUnitId()
        this.getWorkerGoalWorkUnits()

    }

    getPlantingWeightUnitId(){
        const plantingId =this.plantingAndAgriField.planting.id
        this.$apiClient.doRequest('get', `/plantings/${plantingId}`)
        .then((res)=>{
            this.plantingBasicUnitId =  res.basic_unit_id
            this.setDefaultWeightUnit()
        })
    }

    private editMeasurementTiming() {
        this.modalBaseUrl = '/measurement_timings'
        this.showEditModal = true
    }

    private editWeightUnits() {
        this.modalBaseUrl = '/weight_units'
        this.showEditModal = true
    }

    private editQualityStandards() {
        this.modalBaseUrl = '/quality_standards'
        this.showEditModal = true
    }

    private addHarvestRecordData() {
        this.harvestRecordData.push({
            harvestRecordDataId:'',
            harvestRecordId:"",
            weightPerUnit:1,
            qualityStandardId: '',
            qualityStandardName: '',
            quantity: null,
            remainingQuantity:null,
            weightUnitId: this.plantingBasicUnitId || null,
            weightUnitName: '',
            harvestLotNumber:'',
            qualityDisplayFlag:'true',
            processType : 'ADD',
            updatedHarvestRecordData:''
        })
        this.inputChanged();
    }

    private deleteHarvestRecordData(index: number) {
        const record = this.harvestRecordData[index];
        if (record?.harvestRecordDataId) this.deletedHarvestRecordDataIds.push(record.harvestRecordDataId);
        this.harvestRecordData.splice(index, 1)
        this.inputChanged()
    }

    private deletePlantingAndAgriField() {
        this.plantingAndAgriField = {
            agriField: {
                id: '',
                name: '',
                plantedArea: 0
            },
            planting: {
                id: '',
                name: '',
                cropFamicId: ''
            }
        }
        this.plantingBasicUnitId =null
        this.setDefaultWeightUnit();
        this.inputChanged()
    }

    setDefaultWeightUnit(){
        this.plantingBasicUnitId = this.weightUnits.find(wu => wu.id === this.plantingBasicUnitId  && wu.isHidden ===false)?.id ?? null;
       this.harvestRecordData.map(harvest =>{
            if (this.plantingBasicUnitId && !harvest.harvestRecordDataId) {
                harvest.weightUnitId = this.plantingBasicUnitId; 
            }
             else if(!this.plantingBasicUnitId && !harvest.harvestRecordDataId){
                harvest.weightUnitId = null;
            }
       })
    }

    // ロットナンバーの仕様見直しのためUIからコメントアウトされたためロジック側もコメントアウト
    // private checkLotNumber(e: any) {
    //     if(e.target.value){
    //         this.$apiClient.doRequest('get', '/harvest_records/lot_number/' + e.target.value).then(ret => {
    //             this.existLotNumber = true
    //         }).catch(error => {
    //             return
    //         })
    //     }
    // }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if(this.$apiClient.isSizeOver(files)) {
            return
        }

        for (const file of files) {
            if (this.$apiClient.isImageFile(file.name)) {
                this.$apiClient.getBase64(file).then((image: any) => {
                    const item = {
                        file: image.file,
                        url: image.base64
                    } as File
                    this.images.push(item)
                }).catch(() => {
                    window.alert('画像ファイルが読み込めませんでした')
                })
            } else {
                window.alert('画像ファイルを選択してください')
            }
        }
        e.target.value = ''
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if(image.id) {
            this.deletedImages.push(image)
        }
    }

    private validate() {
        const errmsg: string[] = []

        // 日付
        if(!this.date) {
            errmsg.push('日付を選択してください。')
        }

        // 計測タイミング
        if(!this.measurementTimingId) {
            errmsg.push('計測タイミングを選択してください。')
        }

        // 作付・圃場
        if(this.plantingAndAgriField.agriField.id == '' || this.plantingAndAgriField.planting.id == '') {
            errmsg.push('作付・圃場を選択してください。')
        }

        //作業記録内容
        if(this.workRecordOption == 'LINKWORK' && this.workRecordId == '') {
            errmsg.push('紐づける作業記録を選択してください。')
        }

        if (this.workers.length > 0) {
            this.workers.forEach(worker => {
                const quantityStr = worker.quantity != null ? worker.quantity.toString().split('.') : null;
                if (worker.quantity != null && (worker.quantity < 0 || (quantityStr != null && quantityStr[0].length > 7) || (quantityStr != null && quantityStr[1]?.length > 2))) {
                  errmsg.push(`数量は0以上の整数部7桁小数部2桁までの数値を入力してください。(作業者：${worker.worker.name})`);
                }
                if (worker.quantity !== null && String(worker.quantity) !== '' && this.selectedWorkUnitId == null) {
                    if (!errmsg.includes("作業単位を選択してください。")) {
                        errmsg.push("作業単位を選択してください。");
                    }
                }
                if (worker.memo && worker.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${worker.memo.length}文字, 作業者：${worker.worker.name}）`)
                }
                if ((worker.quantity == null || String(worker.quantity) == '') && this.selectedWorkUnitId !== null) {
                    errmsg.push(`数量を入力してください。(作業者：${worker.worker.name})`);
                }
            })
        }
        if (this.machines.length > 0) {
            this.machines.forEach(machine => {
                if (machine.memo && machine.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${machine.memo.length}文字, 機械：${machine.machine.name}）`)
                }
            })
        }

        //収穫データ
        if(this.harvestRecordData.length == 0) {
            errmsg.push('収穫データを入力してください。')
        }else {
            let qualityStandardMessage = ''
            let quantityMessage = ''
            for(const item of this.harvestRecordData) {
                if(!item.qualityStandardId) {
                    qualityStandardMessage = '品質・規格を入力してください。'
                }
                if (!item.quantity || item.quantity == 0) {
                    quantityMessage = '数量を入力してください。';
                } else {
                    const [integer, decimal] = item.quantity.toString().split('.');
                    if (item.quantity < 0 || integer.length > 7 || (decimal?.length > 2)) {
                        quantityMessage = '数量は0以上の整数部7桁小数部2桁までの数値を入力してください。'
                    }
                }
            }
            if(qualityStandardMessage) errmsg.push(qualityStandardMessage)
            if(quantityMessage) errmsg.push(quantityMessage)
        }

        // メモ
        if(this.memo && this.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.memo.length}文字）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private saveRecord() {
        if (this.workRecordOption == "WITHOUTWORK") {
            this.workers = []
            this.machines = []
        }
        if(!this.validate()){
            return
        }
        const params = this.buildHarvestParams();
        const promise = []
        let message = '変更を保存しました。'
        this.updateProcessType(params);
        if(this.modeType === 'edit') {
            if(!window.confirm("内容を上書きして保存します。よろしいですか。")) {
                return false
            }
            this.isLoading = true;
            promise.push(
                this.$apiClient.doRequest("put", `${this.apiBaseUrl}/${this.harvestRecordId}`, params).then(response => {
                    if (response.message) {
                    window.alert(this.alertMessage + response.message);
                    return Promise.reject(response.message);
                    }
                    return response;
                })
            );
        }else {
            message = '保存しました。'
            this.isLoading = true;
            promise.push(this.$apiClient.doRequest("post", this.apiBaseUrl, params))
        }
        Promise.all(promise).then((ret: any) => {
            const imageRequests: any = []
            const uploadImages = this.images.filter((file: File) => !file.id)
            uploadImages.forEach(image => {
                imageRequests.push(this.$apiClient.fileUpload(`${this.apiBaseUrl}/${ret[0].id}/images`, image.file))
            })
            this.deletedImages.forEach(image => {
                imageRequests.push(this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${ret[0].id}/images/${image.id}`))
            })
        
            return Promise.all(imageRequests).then(() => {
                this.deletedImages = []
                this.$store.dispatch('doUpdateIsInputChanged', false);
                this.$emit('update:isRefresh', true);
                this.$toasted.success(message)
                if(this.$route.query.return_to){
                    this.$root.$emit('header-inert', false);
                    this.$router.push(`/${this.$route.query.return_to}?date=${this.date}`).then(() => {return})
                }else {
                    this.closeModal()
                    this.init()
                    if(this.harvestRecordId) {
                        this.getHarvestRecord(this.harvestRecordId)
                    }
                }
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
                this.$toasted.error('写真の保存に失敗しました。')
            })
        }).catch(() => {
            this.isLoading = false;
            this.$toasted.error(this.modeType === 'edit' ? '変更に失敗しました。' : '保存に失敗しました。')
        })
    }

    private deleteRecord() {
        const confirm = window.confirm('削除しますか？')
        const params = this.buildHarvestParams();
        if(confirm && this.harvestRecordId) {
            this.isLoading = true;
            this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${this.harvestRecordId}`,params).then(ret =>{
                if (ret.message) {
                    window.alert(this.alertMessage + ret.message);
                    this.isLoading = false;
                    return Promise.reject(ret.message);
                }
                this.$toasted.success('削除しました。')
                this.editTargetId=''
                this.modeType ='add'
                this.$emit('update:isRefresh', true);
                this.closeModal();
                this.init()
                if(this.$route.query.return_to){
                    this.$router.push('/' + this.$route.query.return_to).then(() => {return})
                }
            this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
                this.$toasted.error('削除に失敗しました。')
            })
        }else if(confirm && !this.harvestRecordId) {
            this.$toasted.error('収穫記録が存在しません。')
        }else {
            this.$toasted.success('削除がキャンセルされました。')
        }
    }

    private buildHarvestRecordData() {
        return this.harvestRecordData.map(data => ({
            harvest_record_data_id: data.harvestRecordDataId,
            quality_standard_id: data.qualityStandardId,
            quantity: data.quantity ? data.quantity : null,
            weight_unit_id:
                (!data.weightUnitId || data.weightUnitId === 'null')
                    ? null
                    : data.weightUnitId,
            harvest_lot_number: data.harvestLotNumber,
            process_type: data.processType,
            updated_harvest_record_data : data.updatedHarvestRecordData
        }));
    }

    private buildHarvestParams() {
        const deletedIds = this.deletedHarvestRecordDataIds.map(String);
        return {
            harvest_date: this.date,
            measurement_timing_id: this.measurementTimingId,
            planting_id: this.plantingAndAgriField.planting.id,
            agri_field_id: this.plantingAndAgriField.agriField.id,
            harvest_record_data: this.buildHarvestRecordData(),
            work_record_id: this.workRecordId ? this.workRecordId : null,
            work_unit_id: this.selectedWorkUnitId,
            deletedHarvestRecordDataIds: this.deletedHarvestRecordDataIds,
            deletedHarvestRecordData: this.originalHarvestRecordData
                .filter(d => deletedIds.includes(d.harvestRecordDataId))
                .map(d => ({
                    harvest_record_deleted_id: d.harvestRecordDataId,
                    harvest_data_updated_time: d.updatedHarvestRecordData
                })),
            workers: this.workers.map(w => {
                const originalWorker = this.originalWorkers.find(orig => orig.worker.id === w.worker.id)
                const workerUpdatedTime = (w.workerUpdatedTime && w.workerUpdatedTime !== "") 
                    ? w.workerUpdatedTime 
                    : originalWorker?.workerUpdatedTime ?? null
                return {
                    worker_id: w.worker.id,
                    start_worktime: w.startWorktime,
                    plan_start_worktime: w.planStartWorktime,
                    actual_start_worktime: w.startWorktime,
                    end_worktime: w.endWorktime,
                    plan_end_worktime: w.planEndWorktime,
                    actual_end_worktime: w.endWorktime,
                    rest_time: w.restTime == null ? 0 : w.restTime,
                    plan_rest_time: w.planRestTime == null ? 0 : w.planRestTime,
                    actual_rest_time: w.restTime == null ? 0 : w.restTime,
                    work_time: w.workTime,
                    plan_work_time: w.planWorkTime,
                    actual_work_time: w.workTime,
                    quantity: w.quantity,
                    kind: "ACTUAL",
                    memo: w.memo,
                    processType: "NOCHANGE",
                    worker_updated_time: workerUpdatedTime
                }
            }),
            deletedWorkers: this.originalWorkers
                .filter(w => !this.workers.find(worker => worker.worker.id === w.worker.id))
                .map(w => w.worker.id),
            deletedWorker: this.originalWorkers
                .filter(w => !this.workers.find(worker => worker.worker.id === w.worker.id))
                .map(w => ({ worker_id: w.worker.id, worker_updated_time: w.workerUpdatedTime })),  
            machines: this.machines.map(m => {
                const originalMachine = this.originalMachines.find(orig => orig.machine.id === m.machine.id)
                const machineUpdatedTime = (m.machineUpdatedTime && m.machineUpdatedTime !== "")
                    ? m.machineUpdatedTime
                    : originalMachine?.machineUpdatedTime ?? null
                return {
                    machine_id: m.machine.id,
                    start_worktime: m.startWorktime,
                    end_worktime: m.endWorktime,
                    rest_time: m.restTime == null ? 0 : m.restTime,
                    work_time: m.workTime,
                    memo: m.memo,
                    processType: "NOCHANGE",
                    machine_updated_time: machineUpdatedTime
                }
            }),
            deletedMachines: this.originalMachines
                .filter(m => !this.machines.find(machine => machine.machine.id === m.machine.id))
                .map(m => m.machine.id),
            deletedMachine: this.originalMachines
                .filter(m => !this.machines.find(machine => machine.machine.id === m.machine.id))
                .map(m => ({machine_id: m.machine.id,machine_updated_time: m.machineUpdatedTime})),
            lot_number: '',
            memo: this.memo,
            workRecordOption: this.workRecordOption,
            updated_harvest_time: this.updatedHarvestTime,
            work_record_updated : this.workRecordUpdated,
            harvest_record_work_records_updated : this.harvestRecordWorkRecordsUpdated,
            shipping_destination_harvest_record_data : this.shippingDestinationsHarvestRecordData?.map(record => ({
                shipping_record_detail_id : record.shippingRecordDetailId,
                harvest_record_data_id : record.harvestRecordDataId,
                updated : record.updated
            }))
        };
    }

    private filterWeightUnitsByDetail(item: HarvestRecordData) {
        return this.weightUnits.filter(wu => item.weightUnitId == wu.id || wu.isHidden === false)
    }

    private changeUnit(item: HarvestRecordData) {
        const selectedUnit = this.weightUnits.find(wu => wu.id === item.weightUnitId && wu.weightPerUnit === null);
        if (selectedUnit) {
            window.alert(`単位「${selectedUnit.name}」の1単位あたりの重量を設定してください。`);
            item.weightUnitId = null;
        }
        this.setProcessType(item);
    }

    get filterMeasurementTimings() {
        return this.measurementTimings
          .filter(m => this.measurementTimingId == m.id || m.isHidden === false)
    }

    private filterQualityStandardsByDetail(item: HarvestRecordData) {
        return this.qualityStandards
          .filter(qs => item.qualityStandardId == qs.id || qs.isHidden === false)
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    cancelRecord() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }   
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if (this.harvestRecordId !== undefined && this.harvestRecordId !== '') {
            this.init()
            this.getHarvestRecord(this.harvestRecordId);
        } else {
            this.init()
        }
     }
    }

    deleteWorker(index: number,workerId:string): void {
        this.workers.splice(index, 1)
        this.inputChanged()
    }

    deleteMachine(index: number): void {
        this.machines.splice(index, 1)
        this.inputChanged()
    }

    private initializeMachines(machines: Machine[]) {
        return machines.map(m => ({
            ...m.machine,
            isHidden: false,
        }))
    }

    private initializeWokers(workers: Worker[]) {
        return workers.map(w => ({
            ...w.worker,
            isHidden: false,
        }))
    }

    private openWorkerSelectTime(idx: number | 'all') {
        const isTime = this.workerInputType === 'TIME_POINT'
        if (isTime) {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const worker = this.workers[idx]
            // 既に作業時間（時刻の時は＋開始・終了時間）が入っているときはそれを初期値とする
            if(worker.workTime > 0 && (!isTime || (worker.startWorktime && worker.endWorktime))) {
                this.targetSelectTime = {
                    startWorktime: worker.startWorktime,
                    endWorktime: worker.endWorktime,
                    restTime: worker.restTime,
                    workTime: worker.workTime,
                }
            }
        }
        this.workerOrMachine = 'WORKER'
        this.inputChanged()
    }

    private openMachineSelectTime(idx: number | 'all') {
        if (this.machineInputType === 'TIME_POINT') {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const machine = this.machines[idx]
            // 既に作業時間が入っているときはそれを初期値とする
            if(machine.workTime > 0) {
                this.targetSelectTime = {
                    startWorktime: machine.startWorktime,
                    endWorktime: machine.endWorktime,
                    restTime: machine.restTime,
                    workTime: machine.workTime
                } as WorkTimeState
            }
        }
        this.workerOrMachine = 'MACHINE'
        this.inputChanged()
    }

    private commitTime(value: WorkTimeState) {
        if (this.workerOrMachine === 'WORKER') {
            if (typeof this.selectTimeIndex === 'number') {
                const worker = this.workers[this.selectTimeIndex]
                this.workers[this.selectTimeIndex] = { ...worker, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.workers = this.workers.map(w => ({ ...w, ...value }))
            }
        } else if (this.workerOrMachine === 'MACHINE') {
            if (typeof this.selectTimeIndex === 'number') {
                const machine = this.machines[this.selectTimeIndex]
                this.machines[this.selectTimeIndex] = { ...machine, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.machines = this.machines.map(m => ({ ...m, ...value }))
            }
        }
        this.targetSelectTime = value
    }

    private commitWorkers(value: { id: string, name: string }[]) {
        const existingWorker = this.workers.filter(w => value.find(v => v.id === w.worker.id) !== undefined)
        const newWorker: Worker[] = value
            .filter(v => this.workers.find(w => w.worker.id === v.id) === undefined)
            .map(v => ({
                worker: v,
                startWorktime: null,
                planStartWorktime: null,
                actualStartWorktime: null,
                endWorktime: null,
                planEndWorktime: null,
                actualEndWorktime: null,
                restTime: null,
                planRestTime: null,
                actualRestTime: null,
                workTime: 0,
                planWorkTime: 0,
                actualWorkTime: 0,
                quantity:null,
                memo: "",
                kind :"SCHEDULE",
                workerUpdatedTime :""
            }))
        this.workers = [...existingWorker, ...newWorker]
    }

    private commitMachines(value: { id: string, name: string }[]) {
        const newMachines: Machine[] = value.map(v => {
            const existingMachine = this.machines.find(m => m.machine.id === v.id)
            return {
                machine: v,
                startWorktime: existingMachine ? existingMachine.startWorktime : null,
                endWorktime: existingMachine ? existingMachine.endWorktime : null,
                restTime: existingMachine ? existingMachine.restTime : null,
                workTime: existingMachine ? existingMachine.workTime : 0,
                memo: existingMachine ? existingMachine.memo : "",
                machineUpdatedTime : existingMachine ? existingMachine.machineUpdatedTime : ""
            }
        })
        this.machines = [...newMachines]
    }

    private updateMachine(value: Item) {
        this.machines.forEach(item => {
            if (value && item.machine.id === value.id) {
                item.machine = value
            }
        })
    }

    private displayTime(time: string | null) {
        return time ? time.slice(0, 5) : ''
    }

    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '0時間0分';
    }
    
    openWorkRecordModal() {
        this.workMode = "edit";
        this.showWork = true;
    }
      
    closeWorkRecordModal() {
        this.workMode = null;
        this.showWork = false;
    }
      
    refreshHarvest () {
        this.refresh = true;
        this.getHarvestRecord(this.harvestRecordId);
    }

    private getWorkUnits() {
        this.$apiClient.doRequest('get', '/work_units?with_hidden=true&is_validate=false').then(res => {
            this.workunits = res.work_units
        }).catch(() => {
            this.$toasted.error('データの取得に失敗しました。');
        })
    }

    private getWorkerGoalWorkUnits(){
        const workItem  = null;
            this.$apiClient.doRequest('get',`/admin/worker_goal_list/work_unit?workItem_id=${workItem}&&planting_id=${this.plantingAndAgriField.planting.id}&&agriField_id=${this.plantingAndAgriField.agriField.id}&&work_date=${this.date}`).then((res) => {
               this.workerGoalWorkUnitId = res.workerGoalWorkUnitId;
               this.selectedWorkUnitId = this.workerGoalWorkUnitId;
                if(this.workerGoalWorkUnitId!=null){
                    this.workerGoalWorkUnitName = this.workunits.find(item=>item.id==this.workerGoalWorkUnitId)?.name
                }else{
                    this.workerGoalWorkUnitName = ''
                }
            })
    }

    private workUnitChange(){
        if(this.selectedWorkUnitId!=null){
            this.workerGoalWorkUnitName = this.workunits.find(item=>item.id==this.selectedWorkUnitId)?.name
        }else{
            this.workerGoalWorkUnitName = ''
        }
        this.inputChanged();
    }

    get filteredWorkUnits() {
        return this.workunits.filter(wu => this.selectedWorkUnitId == wu.id || !wu.is_hidden)
    }

    setProcessType(item: HarvestRecordData) {
        item.processType = item.harvestRecordDataId ? 'UPDATE' : 'ADD';
        this.inputChanged();
    }

    toCamelCase = (str: string) => {
        return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
    };

    compareObject = (original: any, updated: any) => {
        const updatedKeys = Object.keys(updated);
        for (const key of updatedKeys) {
            const originalKey = this.toCamelCase(key);
            if (Object.prototype.hasOwnProperty.call(original, originalKey) && Object.prototype.hasOwnProperty.call(updated, key)) {
                if (original[originalKey] !== updated[key]) {
                    return true;
                }
            }
        }
        return false;
    };

    updateProcessType(params: any ) {
        params.workers.forEach((worker: any) => {
            const originalWorker = this.originalWorkers.find(w => w.worker.id === worker.worker_id);
            if (originalWorker) {
                if (this.compareObject(originalWorker, worker)) {
                    worker.processType = "UPDATE";
                }
            } else {
                worker.processType = "ADD";
            }
        });
    
        params.machines.forEach((machine: any) => {
            const originalMachine = this.originalMachines.find(m => m.machine.id === machine.machine_id);
            if (originalMachine) {
                if (this.compareObject(originalMachine, machine)) {
                    machine.processType = "UPDATE";
                }
            } else {
                machine.processType = "ADD";
            }
        });
    
        return params;
    }

    get isReferenceOnly(): boolean {
        return this.$store.getters.loginUser?.pdWhsRecRefOnly === true;
    }
}
